import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import policyHTML from '../privacy-policy.html?raw'

export default function Privacy() {
  const { t } = useTranslation()
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">{t('legal.backToApp')}</Link>
        <div dangerouslySetInnerHTML={{ __html: policyHTML }} />
      </div>
    </div>
  )
}
